import { useRouteMatchParam } from '@/hooks';
import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

function WorkorderChecklist() {
  const history = useHistory();
  const match = useRouteMatch();
  const complementId = useRouteMatchParam('complementId');

  useEffect(() => {
    if (match.isExact) {
      if (complementId) {
        history.push(
          `/app/movements/workorderChecklist/${complementId}/damages`,
        );
      } else {
        history.push('/app/movements/workOrders');
      }
    }
  }, [match, complementId]);

  return null;
}

export default WorkorderChecklist;
